var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ren-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drafts-(not-for-devving)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-graph",
    transform: "translate(-100.000000, -10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu---wallet-connected",
    transform: "translate(80.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ren-logo",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "11.9502935 0.000818215427 0.000389730092 6.82123667 0.000389730092 7.11616942 3.43079413 5.16560817 3.71139982 5.61840324 5.68577227 4.49565625 5.96559869 4.94845132 13.287068 0.769337767 12.7484612 0.454383358 12.2098544 0.158680443"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "0 11.0979933 0 11.413718 3.43118366 9.46238697 3.71101002 9.91595218 9.45641084 6.64396867 9.71597095 7.09676354 17.0577068 2.91765009 16.5191002 2.60346575 15.9804925 2.30622275 15.7209324 2.14913058"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "0 13.2464594 0 13.561414 3.43118395 11.5900612 3.71100991 12.063648 11.3325719 7.70742083 11.5913528 8.16175616 18.9330883 3.98264247 18.395261 3.68616957 17.8558741 3.37198523 17.5970933 3.21412301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "0 15.3949267 0 15.6898599 3.43118369 13.7385284 3.71100971 14.1920937 13.2679704 8.75162224 13.5267512 9.20595749 20.809248 5.04686502 20.2698616 4.75116213 19.7312542 4.43543765 19.4724735 4.29836702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "0 17.5433932 0 17.838326 3.43118347 15.8877652 3.71100976 16.3413297 15.1425718 9.81738465 15.4021327 10.2902013 22.6838493 6.13110891 22.145243 5.81538442 21.6269013 5.52045159 21.3478545 5.36258936"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "0 19.6918581 0 19.9867911 3.43118357 18.0362306 3.71100989 18.4890254 15.1425727 11.9650805 15.4021336 12.4178757 23.9013672 7.58960213 23.9013672 6.97817477 23.9013672 6.82108265 23.5022835 6.58390429 23.2232364 6.42604208"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "1.47629751 21.2883472 3.39221062 20.2041035 3.67125741 20.6576686 15.0833332 14.1337232 15.3623802 14.6065396 23.9013667 9.71820128 23.9013667 9.10754396 23.9013667 8.49611661 23.9013667 8.2004137 1.21673727 21.1304851"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-8",
    points: "15.0829442 16.2814201 15.3619902 16.755007 23.9009762 11.8666675 23.9009762 11.2560102 23.9009762 10.6445827 23.9009762 10.3488798 3.09250832 22.2147299 3.35206854 22.3718224 5.30695452 21.2483055 5.58600123 21.7018707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "5.22706 23.4368134 7.20221225 22.3132962 7.46177258 22.7861127 15.0833346 18.4298856 15.3623813 18.8834506 23.9013681 14.0151332 23.9013681 13.4044759 23.9013681 12.7930485 23.9013681 12.4780941 4.96749973 23.2789509"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    points: "7.12239524 24.5008812 9.07728125 23.3966158 9.33684133 23.8501807 15.0830213 20.5781974 15.3620678 21.0317629 23.9010534 16.1634456 23.9010534 15.5527884 23.9010534 14.9413611 23.9010534 14.6264067 6.8433485 24.3630406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "8.71865177 25.4274193 8.9976985 25.5852814 10.9533641 24.4617641 11.2121448 24.9345808 15.0829441 22.7268198 15.3619908 23.1803847 23.9017563 18.3120674 23.9017563 17.7014101 23.9017563 17.0699611 23.9017563 16.7750282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    points: "10.6139088 26.5115087 10.873469 26.6493492 12.8283553 25.5450833 13.107402 25.9986486 15.0833338 24.8558799 15.3623803 25.3294666 23.9013672 20.460379 23.9013672 19.8289301 23.9013672 19.2182727 23.9013672 18.9233398"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "0 8.96893292 0 9.26463604 3.4311836 7.3140748 3.71100994 7.76686972 7.58102956 5.55910881 7.84059016 6.01267397 15.1831045 1.83356016 14.6444972 1.53785723 14.1051107 1.22367288 13.8260645 1.06504059"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenLogo);
export default __webpack_public_path__ + "static/media/ren-logo.ad599c7a81ca775ecfe0306e9b7e6a1f.svg";
export { ForwardRef as ReactComponent };